"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var FEATURE_KEY_PREFIX = 'pricing-pages.features';
/*
  Features have their own descriptions which is the default. However,
  some features have a unique description depending on which hub it
  is attached to. Rather than have to attach feature
  descriptions to every single hub though, we model the data to
  represent this as it is in real life... by default each feature
  has its own description, and it can be overridden by having a
  more specific description tied to the hub. This utility helper
  helps black box that logic to implementations.
 */

var getFeatureDescriptionKey = function getFeatureDescriptionKey(featureKey, hubKey) {
  var hasHubSpecificFeature = _HubMap.default[hubKey].hubSpecificFeatures.includes(featureKey);

  var descriptionKey = hasHubSpecificFeature ? hubKey : 'default';
  return FEATURE_KEY_PREFIX + "." + featureKey + ".description." + descriptionKey;
};

var _default = getFeatureDescriptionKey;
exports.default = _default;
module.exports = exports.default;